import { useNavigate } from "react-router-dom";
import LoginButton from "../components/General/LoginButton/LoginButton";
import useAuth from "../hooks/useAuth";
import { useEffect } from "react";
import "../assets/styles/pages/loginPage.css";
import { Box, Typography } from "@mui/material";

const LoginPage = () => {
  const navigate = useNavigate();
  const { isAuthenticated } = useAuth();

  useEffect(() => {
    if (isAuthenticated) {
      navigate("/");
    }
  }, [isAuthenticated, navigate]);

  return (
    <Box className="login-page-background">
      <Box
        sx={{
          my: { xs: 4, md: "200px" },
          px: 2,
        }}
      >
        <Typography
          variant="h4"
          component="h1"
          sx={{
            color: "#fb8c00",
            textAlign: "center",
            marginBottom: "20px",
            zIndex: 1,
          }}
        >
          WELCOME TO C1 HUB
        </Typography>
        <LoginButton />
      </Box>
    </Box>
  );
};

export default LoginPage;
